import { DEFAULT_LANGUAGE } from 'config/languages';
import { getTranslation } from 'lib/dataTransform';

import './AnswerDetail.scss';

/** A question its dynamic modification rule left out of the inspection, shown greyed out. */
export default function SkippedAnswerDetail({ skipped }) {
  const { display } = getTranslation(skipped.questionName, DEFAULT_LANGUAGE);
  return (
    <div className='qm-answer-detail is-hidden is-skipped' data-testid='SkippedAnswerDetail'>
      <div className='table-row question-summary'>
        <div className='table-cell id-cell' />
        <div className='table-cell question-cell'>
          {display}
          <span
            className='skip-tag'
            title={`Skipped by the dynamic modification rule ${skipped.ruleName}`}
          >
            Skip
          </span>
        </div>
        <div className='table-cell question-type-cell'>{skipped.typeLabel}</div>
        <div className='table-cell sample-size-cell' />
        <div className='table-cell toggle-cell' />
      </div>
    </div>
  );
}
